import React from "react";
import clsx from "clsx";

import { usePLPContext } from "../ProductListingPage/ProductListingPage";
import { useQuizContext } from "./QuizCollection";

export const CustomerForm = ({list_ID}) => {
    const { quiz } = usePLPContext();
    const { quizFunctions } = useQuizContext();

    const [email, setEmail] = React.useState('');
    const handleEmailChange = (e) => {
      setEmail(e.target.value);
    };

    const [phoneNum, setPhoneNum] = React.useState('');
    const handlePhoneChange = (e) => {
        setPhoneNum(e.target.value);
    };

    const [phoneNumValid, setPhoneNumValid] = React.useState(false);

    React.useEffect(() => {
        // The component has loaded
        attachPropertiesToForm()

        const debounceFormInput = (callback, wait) => {
            let timeoutId = null;
            return (...args) => {
              window.clearTimeout(timeoutId);
              timeoutId = window.setTimeout(() => {
                callback.apply(null, args);
              }, wait);
            };
        }

        // Phone Number validation.
        const phoneInputFieldKlaviyo = document.querySelector("#phone_number");
        const phoneInputKlaviyo = window.intlTelInput(phoneInputFieldKlaviyo, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
            initialCountry: "AU",
            preferredCountries: ["AU", "NZ", "US", "GB"]
        });

        const checkPhoneNumberKlaviyo = debounceFormInput((ev) => {
            if (phoneInputKlaviyo.isValidNumber())
                setPhoneNumValid(true)
            else
                setPhoneNumValid(false)
        }, 500)
    
        phoneInputFieldKlaviyo.addEventListener('keyup', checkPhoneNumberKlaviyo);
    }, []);

    const handleSubmit = () => {
        quizFunctions.setHasSubmitted(true)
        quiz.setQuizSubmittedOrSkipped(true)
        quizFunctions.handleDataLayer('Quiz_Signup', 'Email & Phone number recorded')
    }
    const handleSkip = () => {
        quiz.setQuizSubmittedOrSkipped(true)
    }

    return (
        <div className={clsx('customer-form container', 
                { 'fadein' : quizFunctions.fadeEffect == 'fadein'},
            )}
        >
            <div className="form-content-container">
                <div className="customer-form-heading-wrapper">
                    <h2>Save 10% on your order!</h2>
                    <p>Enter your email & receive 10% off discount code to use on your leggings purchase!</p>
                </div>
                <form id={'Form-' + list_ID} className="klaviyo_form" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" novalidate="novalidate"
                    onSubmit={handleSubmit}
                >
                    <input
                        type="hidden"
                        name="g"
                        value={list_ID}
                    />
                    <input 
                        className="form_field full" 
                        type="email" 
                        value={email} 
                        name="email" 
                        id="k_id_email" 
                        placeholder="Your Email *" 
                        onChange={handleEmailChange}
                    />
                    
                    <input type="hidden" className="phone-input" name="$phone_number" value={phoneNum}/>
                    <input 
                        className="form_field full"
                        id="phone_number"
                        type="tel"
                        name="phone_number_field"
                        placeholder="Phone Number *"
                        value={phoneNum}
                        onChange={handlePhoneChange}
                    />

                    <div className="klaviyo_form_actions show-results">
                        <button 
                            id="k_submit_button" 
                            className="klaviyo_submit_button button button--contained"
                            disabled={email.length == 0 || !phoneNumValid}
                        >
                            See My Results
                        </button>
                        <button 
                            className="skip-signup"
                            onClick={handleSkip}
                            style={{
                                padding: '4px 14px',
                                borderRadius: '100px',
                                margin: '0 auto'
                            }}
                        >
                            Skip & Show Results
                        </button>
                    </div>
                </form>
            </div>
            <div className="question-image">
                <div className="aspect-ratio-box">
                    <div className={"aspect-content"}>
                    <img className={"media"} src={"https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291"}></img>
                    </div>
                </div>
            </div>
        </div>
    )
}